/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Risk_Short_UnacceptableInputs */



/**
* | output |
* | --- |
* | "Prohibited" |
*
* @param {Audit_Logs_Risk_Short_UnacceptableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_risk_short_unacceptable = /** @type {((inputs?: Audit_Logs_Risk_Short_UnacceptableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Risk_Short_UnacceptableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verboten")
	return /** @type {LocalizedString} */ ("Prohibited")
});